module.exports = __webpack_public_path__ + "static/jolasveinn-og-texti-c8981bd0387fff721d31d584fed4802c.png";